import React, { useEffect, useState } from "react";
import { Form, Col, Button, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";

const TelaImportacao = ({ sqAcaoFiscal, dadosOcorrencia, onUploadSuccess }) => {
  const { request: requestFile, data: dataFile, errors: errorFile, isLoading: loadFile } = useApiClient();
  const [arquivoBaixado, setArquivoBaixado] = useState({});

  const onFileChange = (event) => {
    event.preventDefault();

    const file = event.target.files[0];
    if (!file) return;

    const fileReader = new FileReader();

    fileReader.onload = () => {
      setArquivoBaixado({
        name: file.name,
        type: file.type,
        file: fileReader.result.substring(fileReader.result.indexOf(",") + 1),
      });
    };

    fileReader.onerror = () => {
      toast.error("Erro ao ler o arquivo.");
    };

    fileReader.readAsDataURL(file);
  };

  const uploadPlanilha = () => {
    if (!arquivoBaixado?.file || !dadosOcorrencia) {
      toast.error("Arquivo ou dados da ocorrência estão ausentes.");
      return;
    }

    const parametros = {
      sequencialAcaoFiscal: sqAcaoFiscal,
      sequencialItemOcorrencia: dadosOcorrencia.sqItemOcorrencia,
      arquivo: arquivoBaixado,
      tipoDetalhamento: dadosOcorrencia.tipoDetalhamento,
      composicao: dadosOcorrencia.fgImportacao,
      sentido: dadosOcorrencia.tpSentidoOperacao,
    };

    if (dadosOcorrencia?.tpDetalhamento === "S") {
      requestFile(apiRoutes.fiscalizacao.uploads.uploadExcelSufac, parametros);
    } else {
      requestFile(apiRoutes.fiscalizacao.uploads.uploadExcel, parametros);
    }
  };

  useEffect(() => {
    if (errorFile) {
      toast.error(`Erro ao tentar salvar arquivo: ${errorFile?.message || "Erro desconhecido"}`);
    }
  }, [errorFile]);

  useEffect(() => {
    if (dataFile) {
      toast.success(`Arquivo salvo com sucesso! - ${dataFile?.result}`);
      setTimeout(() => {
        if (typeof onUploadSuccess === "function") {
          onUploadSuccess();
        }
      }, 1000);
    }
  }, [dataFile, onUploadSuccess]);

  return (
    <div className="card shadow">
      <div className="card-body">
        {loadFile && (
          <span>
            <Spinner animation="border" role="status" />
            &nbsp;Carregando ...
          </span>
        )}
        <Form.Group as={Col} sm={10} md={10}>
          <Form.Label className="btn btn-outline-primary btn-md mb-2">
            Escolher planilha
            <Form.Control type="file" accept=".xlsx" onChange={onFileChange} style={{ display: "none" }} />
          </Form.Label>{" "}
          {arquivoBaixado?.name && <span className="text small mt-1">{arquivoBaixado.name}</span>}
          <p className="text-muted small">(Somente .xlsx)</p>
          <Button className="btn-md" onClick={uploadPlanilha}>
            Enviar
          </Button>
        </Form.Group>
      </div>
    </div>
  );
};

export default TelaImportacao;
